import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unlockDevice } from '../../../../../store/actions/auth';
import { useEffectSkipFirst } from '../../../../../hooks/useEffectSkipFirst';
import NumericKeyboard from '../../../VirtualKeyboard/NumericKeyboard';
import ModalIcon from '../../Icon/Icon';
import Title from '../../Title/Title';
import Input from '../../Input/Input';
import { getTranslation } from '../../../../../utils/translation';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import InfoMessage from '../../InfoMessage/InfoMessage';
import Button from '../../Button/Button';

const LockScreen = props => {
    const [input, setInput] = useState({
        value: '',
        showKeyboard: false,
    });
    const { loading, error, isLockedScreen } = useSelector(state => state.auth);
    const { accountNumber } = useSelector(state => state.settings.account.data) || {};
    const dispatch = useDispatch();

    useEffectSkipFirst(() => {
        if (!isLockedScreen && !localStorage.getItem('screenLock')) {
            props.closeModal();
        }
    }, [isLockedScreen]);

    const unLockScreen = () => {
        const { value } = input;

        if (value !== '') {
            const authData = {
                username: accountNumber,
                password: value,
            };

            dispatch(unlockDevice(authData));
        }
    };

    return (
        <>
            {input.showKeyboard && (
                <NumericKeyboard
                    setInputValue={value => setInput({ ...input, value, showKeyboard: false })}
                    close={() => setInput({ ...input, showKeyboard: false })}
                    style={{ bottom: '0', right: '-170px' }}
                />
            )}
            <ModalIcon iconKey='lock' />
            <Title>{getTranslation('lockScreenModalTitle')}</Title>
            <InfoMessage width='380px'>{getTranslation('lockScreenModalDescription')}</InfoMessage>
            <form
                onSubmit={e => {
                    e.preventDefault();
                    unLockScreen();
                    setInput({
                        ...input,
                        showKeyboard: false,
                    });
                }}
            >
                <Input
                    inputType='password'
                    placeholder={getTranslation('lockScreenModalEnterPassword')}
                    value={input.value}
                    onChange={event => setInput({ ...input, value: event.target.value })}
                    showVirtualKeyboard={() =>
                        setInput({
                            ...input,
                            showKeyboard: !input.showKeyboard,
                        })
                    }
                />
                <Button
                    disabled={loading}
                    onClick={unLockScreen}
                    width='200px'
                    autoMargin
                    title={
                        loading
                            ? getTranslation('lockScreenModalSubmitting')
                            : getTranslation('lockScreenModalSubmitButton')
                    }
                />
            </form>
            {error && <ErrorMessage>{error.reason}</ErrorMessage>}
        </>
    );
};

export default LockScreen;
